"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
const i18next_1 = __importDefault(require("i18next"));
const LanguageConfig_1 = require("../../lang/LanguageConfig");
class Language {
    constructor(language) {
        this.languageFunctions = {
            onChange: (event) => this.translate(event.target.value)
        };
        this.languageConfig = new LanguageConfig_1.LanguageConfig(language);
        // If language is not provided from host create language selection control
        if (!language) {
            // This part is to add language selection control component, if no language is provided,
            // now is just commented out, if we will decide to use it in near future
            // const parentEl = document.getElementById('language') as HTMLDivElement;
            // if (!parentEl) throw new Error("Parent element (language) is undefined");
            // this.languageControls = new LanguageControls(parentEl, this.languageConfig);
            // this.addEvents();
        }
        this.translatableElements = document.querySelectorAll('[' + this.languageConfig.translationDataKey + '], [' + this.languageConfig.translationDataAttr + ']');
        this.initializeLanguages(this.languageConfig.selected);
    }
    updateTranslatableElements() {
        this.translatableElements = document.querySelectorAll('[' + this.languageConfig.translationDataKey + '], [' + this.languageConfig.translationDataAttr + ']');
        this.translate(this.languageConfig.selected);
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.languageControls) === null || _a === void 0 ? void 0 : _a.dispose();
        delete this.languageControls;
        delete this.translatableElements;
    }
    translate(language) {
        i18next_1.default.changeLanguage(language)
            .then((t) => {
            var _a;
            (_a = this.translatableElements) === null || _a === void 0 ? void 0 : _a.forEach((el) => {
                // Translate element inner html
                const inner = el.getAttribute(this.languageConfig.translationDataKey);
                if (inner)
                    el.innerHTML = i18next_1.default.t(inner);
                // Translate element other attributes
                const translateAttributeString = el.getAttribute(this.languageConfig.translationDataAttr);
                if (!translateAttributeString)
                    return;
                const translateAttributes = translateAttributeString.split(' ');
                translateAttributes.forEach(translateAttribute => {
                    const attributeKeyVal = translateAttribute.split('=');
                    if (attributeKeyVal.length < 2)
                        throw new Error("Keys and values of " + this.languageConfig.translationDataAttr + ", should be formated as `key=val`");
                    const key = attributeKeyVal[0];
                    const val = attributeKeyVal[1];
                    el.setAttribute(key, i18next_1.default.t(val));
                });
            });
        });
    }
    addEvents() {
        var _a, _b;
        (_b = (_a = this.languageControls) === null || _a === void 0 ? void 0 : _a.languageSelect) === null || _b === void 0 ? void 0 : _b.setEvent('change', this.languageFunctions.onChange);
    }
    removeEvents() {
        var _a, _b;
        (_b = (_a = this.languageControls) === null || _a === void 0 ? void 0 : _a.languageSelect) === null || _b === void 0 ? void 0 : _b.removeEvent('change', this.languageFunctions.onChange);
    }
    initializeLanguages(language) {
        return __awaiter(this, void 0, void 0, function* () {
            yield i18next_1.default.init({
                lng: language,
                fallbackLng: this.languageConfig.default,
                supportedLngs: this.languageConfig.supported,
                nonExplicitSupportedLngs: true,
                resources: this.languageConfig.resources
            });
            this.translate(language);
        });
    }
}
exports.Language = Language;
